import { render, staticRenderFns } from "./CCSS.vue?vue&type=template&id=5a147a74&scoped=true&"
import script from "./CCSS.ts?vue&type=script&lang=ts&"
export * from "./CCSS.ts?vue&type=script&lang=ts&"
import style0 from "./CCSS.vue?vue&type=style&index=0&id=5a147a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a147a74",
  null
  
)

export default component.exports